module.exports = __webpack_public_path__ + "img/image_7.857b061e.jpg";